import { Saveable } from './saveable';

/**
 * Factory methods for quickly creating common types of Saveable states
 */
export class SaveableFactory {
  /**
   * Create a Saveable mask without tracking or error states
   * @return {Saveable} A Saveable representing the reset state.
   */
  static reset(): Saveable {
    return {
      deletionError: undefined,
      isDeleting: undefined,
      isSaving: undefined,
      isSaved: undefined,
      savingError: undefined,
    };
  }

  /**
   * Create a Saveable mask representing a Saveable in process of saving
   * @return {Saveable} A Saveable representing saving data.
   */
  static saving(): Saveable {
    return Object.assign(this.reset(), {
      isSaving: true,
    });
  }

  /**
   * Create a Saveable mask representing a Saveable in process of saving
   * @return {Saveable} A Saveable representing saving data.
   */
  static saved(): Saveable {
    return Object.assign(this.reset(), {
      isSaved: true,
    });
  }

  /**
   * Create a Saveable mask representing an error whilst saving
   * @return {Saveable} A Saveable representing lan error whilst saving
   */
  static errorSaving(error: any): Saveable {
    return Object.assign(this.reset(), {
      savingError: error,
    });
  }

  /**
   * Create a Saveable mask representing a Saveable in process of deleting
   * @return {Saveable} A Saveable representing deleting data.
   */
  static deleting(): Saveable {
    return Object.assign(this.reset(), {
      isDeleting: true,
    });
  }

  /**
   * Create a Saveable mask representing an error whilst deleting
   * @return {Saveable} A Saveable representing an error whilst deleting
   */
  static errorDeleting(error: any): Saveable {
    return Object.assign(this.reset(), {
      deletionError: error,
    });
  }
}
